export const POST_USER_ROLE = `
    mutation PostUserRole(
        $tenantId: String!
        $aziendaId: Int!
        $dataInput: InputDataUserRole!
    ) {
        postUserRole(
            tenantId: $tenantId
            aziendaId: $aziendaId
            dataInput: $dataInput
        ) {
            id
            tenantId
            userId
            role
            dateStart
            dateEnd
            aziendaId
        }
    }
`;
export const UPDATE_USER_ROLE = `
	mutation UpdateUserRole(
		$id: Int!
		$userId: String!
		$tenantId: String!
		$aziendaId: Int!
		$dataInput: InputDataUserRole!
	) {
		updateUserRole(
			id: $id
			userId: $userId
			tenantId: $tenantId
			aziendaId: $aziendaId
			dataInput: $dataInput
		) {
			id
			tenantId
			userId
			role
			dateStart
			dateEnd
			aziendaId
		}
	}
`;
export const DELETE_USER_ROLE = `
	mutation DeleteUserRole(
		$id: Int!
		$userId: String!
		$tenantId: String!
		$aziendaId: Int!
	) {
		deleteUserRole(
			id: $id
			userId: $userId
			tenantId: $tenantId
			aziendaId: $aziendaId
		) {
			success
			message
		}
	}
`;
